import { ChevronRight } from "lucide-react";
import React from "react";

import { IgAccordion } from "@intelligems/ig-theme/IgAccordion";
import Stack from "@mui/material/Stack";
import { OtherGroupModCard } from "@src/features/experienceBuilder/modifications/copyMod/OtherGroupModCard";
import { useDispatch, useSelector } from "@src/store";
import {
  ExperienceBuilderAction as Action,
  ExperienceBuilderSelector as Selector,
} from "@src/store/slices/experienceBuilder";

export const CopyFromOtherGroupsAccordion = () => {
  const dispatch = useDispatch();
  const otherGroupsMods = useSelector(Selector.getOtherGroupsMods);
  const expanded = useSelector(Selector.areOtherModsExpanded);

  if (otherGroupsMods.length === 0) {
    return null;
  }

  return (
    <IgAccordion
      title="Copy & edit from other groups"
      titleVariant="body1"
      expanded={expanded}
      onChange={() => dispatch(Action.setOtherModsExpanded(!expanded))}
      hideSummaryActionButtons
      headerIcon={
        <ChevronRight
          size={16}
          style={{
            transform: expanded ? "rotate(90deg)" : "rotate(0deg)",
            transition: "transform 0.2s",
          }}
        />
      }
      sx={{
        border: "none !important",
        backgroundColor: "transparent",
        padding: 0,
        "&:hover": {
          border: "none !important",
          boxShadow: "none !important",
        },
      }}
      accordionSummaryProps={{
        sx: { py: 4, px: 0, minHeight: "unset" },
      }}
      accordionDetailsProps={{
        sx: { pt: 4, px: 0 },
      }}
    >
      <Stack spacing={5}>
        {otherGroupsMods.map((group, index) => (
          <OtherGroupModCard
            key={`${group.selector}-${index}`}
            selector={group.selector}
            mods={group.mods}
          />
        ))}
      </Stack>
    </IgAccordion>
  );
};
